import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  loading: {
    alignSelf: 'center',
  },
  container: {
    width: '370px',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 36px',
    gap: '24px',
    wordBreak: 'keep-all!important',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  header: {
    fontSize: '20px',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
  },
  labelInput: {
    '&::placeholder': {
      color: '#888888',
      fontSize: '14px',
      border: 'none!important',
    },
    minWidth: '0px',
    maxWidth: '-webkit-fill-available',
    height: '36px',
    borderRadius: '6px',
    padding: '8px 12px',
    color: '#fff',
    backgroundColor: '#292929',
    border: '1px solid #404040',
    fontSize: '14px',
    outline: 'none',
  },
  radioButtonContainer: {
    display: 'flex!important',
    flexDirection: 'row!important',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '1rem',
    marginBottom: '10rem',
  },
  radioButton: {
    color: '#fff!important',
  },
  radioButtonLabel: {
    fontSize: '14px',
    fontWeight: '300',
    color: '#9A9A9A',
    display: 'flex',
    fontSize: '14px!important',
    alignItems: 'center',
  },
  formControlLabel: {
    '&.MuiFormControlLabel-root': {
      margin: '0!important',
    },
  },
  formControlLabelText: {
    fontWeight: '300',
    color: '#9A9A9A',
    display: 'flex',
    fontSize: '14px',
    alignItems: 'center',
    fontFamily: 'inherit',
  },
  dragAndDropContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dragAndDrop: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dragAndDropText: {
    fontWeight: '300',
    fontSize: '14px',
    color: '#8A8A8A',
  },
  dragAndDropButton: {
    marginTop: '12px',
    fontWeight: '300',
    fontSize: '14px',
    color: '#F2F2F2',
    backgroundColor: '#202020',
    borderRadius: '0.4rem',
    padding: '0.5rem 1.5rem',
    color: '#1D1D1D',
    backgroundColor: '#F0F0F0',
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  coverImg: {
    userSelect: 'none',
    width: '96px',
    height: '96px',
    borderRadius: '6px',
    border: '1px solid #404040',
  },
  deleteButtonImg: {
    userSelect: 'none',
    marginLeft: '0.5rem',
    flexShrink: '0',
    cursor: 'pointer',
  },
  buttonContainer: {
    display: 'flex',
    gap: '12px',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: '3px',
    borderRadius: '3px',
    color: '#c4c4c4',
    height: '40px',
    width: '135px',
    fontSize: '15px',
  },
  yesButton: {
    border: '1px solid #c4c4c4',
    color: '#191919',
    backgroundColor: '#c4c4c4',
    '&:hover': {
      background: '#d1fe75',
      color: '#1e1e1e',
      border: '1px solid #d1fe75',
    },
  },
  noButton: {
    border: '1px solid #a4a4a4',
    '&:hover': {
      background: '#d1fe75',
      color: '#1e1e1e',
      border: '1px solid #d1fe75',
    },
  },
}));

export { useStyles };
